import React, { useState } from 'react';
import { Box, TextField, Typography, Button } from '@mui/material';
import OneOncologyLogo from 'assets/one-oncology-logo-small.svg';
import { RequestSupportPageContainer } from './HelpCenter.styled';
import {
  AlertSeverity,
  EmailRequest,
  setAlert,
  useAppDispatch,
  useAppSelector,
  useSendEmailMutation,
} from 'api';
import { useNavigate } from 'react-router-dom';

export const RequestSupportPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [bodyValue, setBodyValue] = useState<string>('');
  const [postAction, { isLoading: isSending }] = useSendEmailMutation();
  const { currentMenuItem } = useAppSelector(state => state.menuItem);
  const { mockUser } = useAppSelector(state => state.appUser);

  const handleBodyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBodyValue(event.target.value);
  };

  const handleSend = async () => {
    let responseState = { message: '', status: AlertSeverity.Success };
    try {
      const subject = currentMenuItem?.powerBIReportName
        ? `OneAnalytics Help Request for ${currentMenuItem?.description} from ${mockUser?.userName}, ${mockUser?.displayName}, ${mockUser?.email}`
        : `OneAnalytics Help Request from ${mockUser?.userName}, ${mockUser?.displayName}, ${mockUser?.email}`;
      const emailRequest: EmailRequest = {
        to: currentMenuItem?.supportEmail,
        body: bodyValue,
        subject: subject,
        isHtml: true,
      };
      const response: any = await postAction(emailRequest);
      if (response.error) {
        responseState.message = 'Something went wrong.';
        responseState.status = AlertSeverity.Error;
      } else {
        responseState.message = 'Email sent.';
        responseState.status = AlertSeverity.Success;
      }
    } catch (e) {
      responseState.message = 'Something went wrong.';
      responseState.status = AlertSeverity.Error;
    }
    dispatch(
      setAlert({
        message: responseState.message,
        severity: responseState.status,
      })
    );

    if (responseState.status === AlertSeverity.Success) navigate('/helpCenter');
  };

  return (
    <RequestSupportPageContainer>
      <Box display="flex" alignItems="center" marginRight="2em">
        <Box
          component="img"
          sx={{ color: '#0EAA7C', height: '7em' }}
          src={OneOncologyLogo}
        />
        <Typography variant="h4">Request Support</Typography>
      </Box>
      <Box display="flex" flexDirection="column" gap="1em">
        <TextField
          sx={{ width: '450px' }}
          label="Request Support"
          multiline
          rows={7}
          onChange={handleBodyChange}
        />
        <Button
          variant="contained"
          onClick={handleSend}
          loading={isSending}
          loadingPosition="start"
          sx={{ width: '100px', alignSelf: 'flex-end' }}
          fullWidth
        >
          <span style={{ paddingTop: '3px' }}>Submit</span>
        </Button>
      </Box>
    </RequestSupportPageContainer>
  );
};
